import { render, staticRenderFns } from "./BulkDeleteBlockedTable.vue?vue&type=template&id=3adc7e65&scoped=true"
import script from "./BulkDeleteBlockedTable.vue?vue&type=script&lang=js"
export * from "./BulkDeleteBlockedTable.vue?vue&type=script&lang=js"
import style0 from "./BulkDeleteBlockedTable.vue?vue&type=style&index=0&id=3adc7e65&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3adc7e65",
  null
  
)

export default component.exports